import type { Action } from 'vuex';
import {
  fetchAssessmentStatus,
  confirmAnswerControlUpdate as confirmAnswerControlUpdateRequest,
  submitAssessment as submitAssessmentRequest,
} from '../api/assessment';
import type { AssessmentState } from './mutations';

const getAssessmentStatus: Action<AssessmentState, any> = async ({ commit }) => {
  const res = await fetchAssessmentStatus();
  commit('SET_ASSESSMENT_STATUS', res.data);
};

const confirmAnswerControlUpdate: Action<AssessmentState, any> = async (_store, answerID) => {
  await confirmAnswerControlUpdateRequest(answerID);
};

const submitAssessment: Action<AssessmentState, any> = async ({ commit }) => {
  const res = await submitAssessmentRequest();
  commit('SET_ASSESSMENT_STATUS', res.data);
};

export const actions = {
  getAssessmentStatus,
  submitAssessment,
  confirmAnswerControlUpdate,
};
